import { forwardRef, memo } from 'react';

import { cn } from '../../lib/styles';
import { Label } from '../Label';

interface TextareaProps extends React.ComponentProps<'textarea'> {
  label?: string;
  textareaClassName?: string;
}

const TextareaBase = (
  { className, label, id, textareaClassName, ...props }: TextareaProps,
  ref: React.ForwardedRef<HTMLTextAreaElement>,
) => {
  const textareaInput = (
    <textarea
      ref={ref}
      id={id}
      data-slot="textarea"
      className={cn(
        'flex px-2.5 py-2 font-body-md font-medium resize-none w-full bg-bg-inter-secondary-default field-sizing-content rounded-sm',
        'outline-1 outline-bg-inter-secondary-default focus-visible:outline-border-input-select transition-all',
        'enabled:text-text-primary disabled:text-text-disabled',
        label ? textareaClassName : className,
      )}
      {...props}
    />
  );

  if (!label) return textareaInput;

  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <Label htmlFor={id}>{label}</Label>

      {textareaInput}
    </div>
  );
};

export const Textarea = memo(forwardRef(TextareaBase));
